import { render, staticRenderFns } from "./SlPanel.vue?vue&type=template&id=2dddbd8f&"
import script from "./SlPanel.vue?vue&type=script&lang=js&"
export * from "./SlPanel.vue?vue&type=script&lang=js&"
import style0 from "./SlPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports